import React from "react";
import {withRouter} from 'react-router-dom';

import MaterialTable from 'material-table';

import { CSVLink } from "react-csv";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AttachMoney from "@material-ui/icons/AttachMoney";
import DateRange from "@material-ui/icons/DateRange";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import LocalAtm from "@material-ui/icons/LocalAtm";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import axios from "axios";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { API_ROOT, SUPPORT_EMAIL } from 'api-config';
import { convertToCurrency, convertToDisplayDate } from "../../assets/helpers/dataHelper";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Datetime from "react-datetime";
import { validateDateFormatAndOrder } from "../../assets/helpers/formHelper";
import SweetAlert from "react-bootstrap-sweetalert";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import { cirrusBlueColor } from "assets/jss/material-dashboard-pro-react.jsx";
import { getUserGroups } from "../../assets/helpers/utilityHelper";
const tableStyle = require('../../assets/style/tableStyle.json');
var tableOptions = require('../../assets/style/tableOptions.json');
tableOptions = JSON.parse(JSON.stringify(tableOptions));
var moment = require('moment');

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  dateTimeAlignmentFix: {
    marginTop: "-20px"
  },
  ...sweetAlertStyle,
  ...dashboardStyle
};
var accountingLoadingData = []
accountingLoadingData['id'] = 0
accountingLoadingData['transactionDatetime'] = 'loading...'
accountingLoadingData['transactionAmount'] = 'loading...'
accountingLoadingData['payOutAmount'] = 'loading...'
accountingLoadingData['currentBalance'] = 'loading...'
accountingLoadingData['currentBalanceWithBonus'] = 'loading...'
accountingLoadingData['toUserFullName'] = 'loading...'
accountingLoadingData['fromUserFullName'] = 'loading...'
accountingLoadingData['actions'] = ''
accountingLoadingData = [accountingLoadingData]

var depositsLoadingData = []
depositsLoadingData['transactionDate'] = 'loading...'
depositsLoadingData['totalPayoutAmount'] = 'loading...'
depositsLoadingData['transactionCount'] = 'loading...'
depositsLoadingData['achFilename'] = 'loading...'
depositsLoadingData = [depositsLoadingData]

class ReactTables extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    var transactionType = '';
    var transactionFilterBy = '';
    var pageTitle = '';
    var showDeleteTransaction = false
    var showRunningBalance = false
    var showPayoutAmount = true
    var showDeposits = true
    var showUpcomingCharges = false
    var userGroups = getUserGroups()
    var batchTransactionType = 'deposit'
    var showOrgMemberList = false
    var showDiscountedAmount = false
    if (userGroups.indexOf('patient') >= 0) {
      showOrgMemberList = true
    }

    var showNestEggSummaryData = false
    var exportHeaders = [{ label: "transaction ID", key: "id" },
      { label: "transaction date", key: "date" },
      { label: "credit/debit", key: "creditDebit" },
      { label: "amount", key: "amount" },
      { label: "amount minus fee", key: "paymentAmount" },
      { label: "transaction from", key: "from" },
      { label: "transaction to", key: "to" }]
    var depositExportHeaders = [
      { label: "deposit date", key: "transactionDate" },
      { label: "deposit amount", key: "totalPayoutAmount" },
      { label: "# transactions", key: "transactionCount" },
      { label: "deposit ID", key: "achFilename" }]
    if (this.props.location.pathname === '/pendingTransactions') {
      transactionType = 'P'
      showDeleteTransaction = true
      pageTitle = 'pending transactions'
      showPayoutAmount = false
      showDeposits = false
      exportHeaders = [{ label: "transaction ID", key: "id" },
        { label: "transaction date", key: "date" },
        { label: "credit/debit", key: "creditDebit" },
        { label: "amount", key: "amount" },
        { label: "transaction from", key: "from" },
        { label: "transaction to", key: "to" }]
    } else {
      transactionType = 'F'
      pageTitle = 'accounting'
      if (userGroups.indexOf('patient') >= 0) {
        showNestEggSummaryData = true
        showRunningBalance = true
        showPayoutAmount = false
        showDeposits = false
        showDiscountedAmount = true
        exportHeaders = [{ label: "transaction ID", key: "id" },
          { label: "transaction date", key: "date" },
          { label: "credit/debit", key: "creditDebit" },
          { label: "amount", key: "amount" },
          { label: "balance", key: "currentBalance" },
          { label: "transaction from", key: "from" },
          { label: "transaction to", key: "to" }]
      } else if (userGroups.indexOf('employer') >= 0) {
        showDeposits = true
        showUpcomingCharges = true
        showPayoutAmount = false
        transactionFilterBy = 'toParent'
        batchTransactionType = 'withdrawal'
        depositExportHeaders = [
          { label: "withdrawal date", key: "transactionDate" },
          { label: "withdrawal amount", key: "totalPayoutAmount" },
          { label: "# transactions", key: "transactionCount" },
          { label: "withdrawal ID", key: "achFilename" }]
      }

    }

    this.state = {
      data: [],
      exportData: [],
      depositData: [],
      depositExportData: [],
      exportHeaders: exportHeaders,
      depositExportHeaders: depositExportHeaders,
      startDate: '',
      endDate: '',
      depositStartDate: '',
      depositEndDate: '',
      alert: '',
      transactionType: transactionType,
      transactionFilterBy: transactionFilterBy,
      showDeleteTransaction: showDeleteTransaction,
      showNestEggSummaryData: showNestEggSummaryData,
      showRunningBalance: showRunningBalance,
      showPayoutAmount: showPayoutAmount,
      pageTitle: pageTitle,
      totalBalance: '0.00',
      nestEggBonusAmount: '0',
      showDownloadData: false,
      showDeposits: showDeposits,
      showUpcomingCharges: showUpcomingCharges,
      showDepositDownloadData: false,
      showRunningBalanceWithBonus: false,
      showOrgMemberList: showOrgMemberList,
      selectedOrgMember: sessionStorage.getItem('userId'),
      orgMembers: [],
      showOrgMembersTransactions: false,
      totalMonthlyCost: '',
      numMembers: '',
      nextChargeDate: '',
      employeeText: 'employees',
      batchTransactionType: batchTransactionType,
      showDiscountedAmount: showDiscountedAmount
    }
  }
  componentDidMount() {
    this._isMounted = true;
    this.loadUserAccountingInfo(sessionStorage.getItem('userId'))
    if (this.state.showOrgMemberList === true) {
      axios.get(`${API_ROOT}/childAccount/?userId=` + sessionStorage.getItem('userId') + `&includeSelf=true`, { headers: getApiHeaders() })
        .then(res => this.setOrgMembers({ responseMessage: res.data }));
    }
    if (this.state.showUpcomingCharges) {
      axios.get(`${API_ROOT}/upcomingCharges/?userId=` + sessionStorage.getItem('userId') + `&numMonths=1&orgType=E&signedAgreement=true`, { headers: getApiHeaders() })
        .then(res => this.setUpcomingCharges({ responseMessage: res.data }));
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadUserAccountingInfo(userId) {
    this.setAccountingTableLoading()
    var showOrgMembersTransactions = false
    if (userId === 'all') {
      userId = sessionStorage.getItem('userId')
      showOrgMembersTransactions = true
    }
    this.setState({
      showOrgMembersTransactions: showOrgMembersTransactions
    });
    var queryString = 'userId=' + userId + '&transactionType=' + this.state.transactionType + '&showOrgMembers=' + showOrgMembersTransactions
    if (this.state.transactionFilterBy) {
      queryString += '&filterBy=' + this.state.transactionFilterBy
    }
    axios.get(`${API_ROOT}/financialTransactions/?` + queryString, {headers: getApiHeaders()})
      .then(res => this.setTableValues({responseMessage: res.data}));

    if (this.state.showNestEggSummaryData && showOrgMembersTransactions === false) {
      axios.get(`${API_ROOT}/financialTransactionsSummary/?userId=`+ userId+`&includeBonusAmount=true`, {headers: getApiHeaders()})
        .then(res => this.setTotalBalance({responseMessage: res.data}));
    }
    if (this.state.showDeposits) {
      this.setDepositTableLoading()
      queryString = 'userId=' + userId
      if (this.state.transactionFilterBy) {
        queryString += '&filterBy=' + this.state.transactionFilterBy
      }
      axios.get(`${API_ROOT}/deposits/?` + queryString  +
        `&transactionType=` + this.state.transactionType, { headers: getApiHeaders() })
        .then(res => this.setDepositTableValues({ responseMessage: res.data }));
    }
  }

  setTotalBalance(res) {
    if (this._isMounted) {
      var showRunningBalanceWithBonus;
      if (res.responseMessage.bonusAmount && res.responseMessage.bonusAmount !== '0.00') {
        showRunningBalanceWithBonus = true
      } else {
        showRunningBalanceWithBonus = false
      }
      this.setState({
        totalBalance: res.responseMessage.totalWithBonus,
        nestEggBonusAmount: res.responseMessage.bonusAmount,
        showRunningBalanceWithBonus: showRunningBalanceWithBonus
      })
    }
  }
  setTableValues(res) {
    if (this._isMounted) {
      this.setState({
        data: res.responseMessage.map((prop, key) => {
          var transactionAmount = prop.transactionAmount
          if (this.state.showDiscountedAmount) {
            transactionAmount = prop.transactionAmountWithDiscount
          }
          return {
            id: prop.id,
            transactionDatetime: convertToDisplayDate(prop.transactionDatetime),
            transactionAmount: prop.transactionSign + convertToCurrency(transactionAmount),
            payOutAmount: prop.transactionSign + convertToCurrency(prop.payOutAmount),
            currentBalance: convertToCurrency(prop.currentBalance),
            currentBalanceWithBonus: convertToCurrency(prop.currentBalanceWithBonus),
            toUserFullName: prop.toUserFullName,
            fromUserFullName: prop.fromUserFullName,
            actions: (
              <div className="actions-right">
                {/* use this button to add a edit kind of action */}
                <Button
                  justIcon
                  simple
                  size="sm"
                  onClick={this.deletePendingTransactionConfirm.bind(this, prop.id, prop.transactionAmount, prop.user_id)}
                  color="danger"
                  className="edit"
                >
                  <Close/>
                </Button>{" "}
              </div>
            )
          };
        }),
        exportData: res.responseMessage.map((prop, key) => {
          return {
            id: prop.id,
            date: convertToDisplayDate(prop.transactionDatetime),
            creditDebit: prop.transactionSign,
            amount: prop.transactionAmount,
            paymentAmount: prop.payOutAmount,
            currentBalance: prop.currentBalance,
            from: prop.fromUserFullName,
            to: prop.toUserFullName
          };
        }),
        showDownloadData: true
      });
    }
  }

  setAccountingTableLoading() {
    this.setState({
      data: accountingLoadingData.map((prop, key) => {
        return {
          id: prop.id,
          transactionDatetime: prop.transactionDatetime,
          transactionAmount: prop.transactionAmount,
          payOutAmount: prop.payOutAmount,
          currentBalance: prop.currentBalance,
          currentBalanceWithBonus: prop.currentBalanceWithBonus,
          toUserFullName: prop.toUserFullName,
          fromUserFullName: prop.fromUserFullName,
          actions: prop.actions
        };
      })
    });
  }

  setDepositTableValues(res) {
    if (this._isMounted) {
      this.setState({
        depositData: res.responseMessage.map((prop, key) => {
          return {
            transactionDate: convertToDisplayDate(prop.transactionDate),
            totalPayoutAmount: convertToCurrency(prop.totalPayoutAmount),
            transactionCount: prop.transactionCount,
            achFilename: prop.achFilename
          };
        }),
        depositExportData: res.responseMessage.map((prop, key) => {
          return {
            transactionDate: convertToDisplayDate(prop.transactionDate),
            totalPayoutAmount: prop.totalPayoutAmount,
            transactionCount: prop.transactionCount,
            achFilename: prop.achFilename
          };
        }),
        showDepositDownloadData: true
      });
    }
  }

  setDepositTableLoading() {
    this.setState({
      depositData: depositsLoadingData.map((prop, key) => {
        return {
          transactionDate: prop.transactionDate,
          totalPayoutAmount: prop.totalPayoutAmount,
          transactionCount: prop.transactionCount,
          achFilename: prop.achFilename
        };
      })
    });
  }

  setOrgMembers(res) {
    if (this._isMounted) {
      const orgMembers = res.responseMessage
      if (orgMembers.length > 1) {
        const allMembersRow = {organizationId: sessionStorage.getItem('userId'), userId: "all", isPrimary: "1", orgType: "M", name: "all"}
        orgMembers.push(allMembersRow)
      }
      this.setState({
        orgMembers: res.responseMessage
      })
    }
  }

  setUpcomingCharges(res) {
    if (this._isMounted) {
      var employeeText = 'employees'
      if (res.responseMessage.numMembers === 1) {
        employeeText = 'employee'
      }
      this.setState({
        totalMonthlyCost: res.responseMessage.totalMonthlyCost,
        numMembers: res.responseMessage.numMembers,
        nextChargeDate: res.responseMessage.nextChargeDate,
        employeeText: employeeText
      })
    }
  }
  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });

  }

  handleOrgMemberSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
    this.loadUserAccountingInfo(event.target.value)
  }


  handleDateChange(event, dateType) {
    var dateValue = '';
    if (event instanceof moment) {
      dateValue = event.format("MM/DD/YYYY")
    } else {
      dateValue = event
    }
    this.setState({
      [dateType]: dateValue
    })
  }

  filterAccounting(res) {
    if (this._isMounted) {
      if (res.data) {
        if (res.data.message === 'success') {
          this.hideAlert()
        } else {
          this.setState({
            alert: (
              <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Error"
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnCssClass={
                  this.props.classes.button + " " + this.props.classes.success
                }
              >
                There was an error deleting the pending transaction.
                Please try again. If this issue persists, please contact support at {SUPPORT_EMAIL}.
              </SweetAlert>
            )
          });
        }
      }
      var validDateInfo = validateDateFormatAndOrder(this.state.startDate, this.state.endDate)
      var validStartDate = validDateInfo.validStartDate
      var validEndDate = validDateInfo.validEndDate
      var alertMessage = validDateInfo.alertMessage
      if (alertMessage) {
        this.setState({
          alert: (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="check the dates"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
            >
              {alertMessage}
            </SweetAlert>
          )
        });
      } else {
        if (!validStartDate) {
          validStartDate = '';
        }
        if (!validEndDate) {
          validEndDate = '';
        }
        this.setState({
          showDownloadData: false
        })
        this.setAccountingTableLoading()
        axios.get(`${API_ROOT}/financialTransactions/?userId=` + sessionStorage.getItem('userId') +
          `&transactionType=` + this.state.transactionType + `&startDate=` + validStartDate +
          `&endDate=` + validEndDate, { headers: getApiHeaders() })
          .then(res => this.setTableValues({ responseMessage: res.data }));
      }
    }
  }

  filterDeposits() {

    var validDateInfo = validateDateFormatAndOrder(this.state.depositStartDate, this.state.depositEndDate)
    var validStartDate = validDateInfo.validStartDate
    var validEndDate = validDateInfo.validEndDate
    var alertMessage = validDateInfo.alertMessage

    if (alertMessage) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="check the dates"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            {alertMessage}
          </SweetAlert>
        )
      });
    } else {
      if (!validStartDate) {
        validStartDate = '';
      }
      if (!validEndDate) {
        validEndDate = '';
      }
      this.setState({
        showDepositDownloadData: false
      })
      this.setDepositTableLoading()
      axios.get(`${API_ROOT}/deposits/?userId=` + sessionStorage.getItem('userId') +
        `&transactionType=` + this.state.transactionType + `&startDate=` + validStartDate +
        `&endDate=` + validEndDate, { headers: getApiHeaders() })
        .then(res => this.setDepositTableValues({ responseMessage: res.data }));
    }
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }


  deletePendingTransactionConfirm(tranactionId, tranactionAmount, toUserId) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure you want to delete the charge?"
          onConfirm={() => this.deletePendingTransaction(tranactionId, toUserId)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes, delete!"
          cancelBtnText="Cancel"
          showCancel
        >
          If you delete the pending charge for ${tranactionAmount}, the patient account will not be billed this amount.
        </SweetAlert>
      )
    });
  }

  deletePendingTransaction(tranactionId, toUserId) {
    const chargeData = {
      userId: toUserId,
      transactionId: tranactionId
    }
    axios.delete(`${API_ROOT}/financialTransactions/`, {data: chargeData, headers: getApiHeaders()})
      .then(res => this.filterAccounting(res));

  }

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        {this.state.alert}
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card style={this.state.showUpcomingCharges ? {} : { display: 'none' }}>
            <CardHeader color="success" stats icon>
              <CardIcon  color="cirrusBlue">
                <AttachMoney />
              </CardIcon>
              <p className={classes.cardCategory}>upcoming charges</p>
              <h3 className={classes.cardTitle} id="upcomingCharges">{convertToCurrency(this.state.totalMonthlyCost)}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <AssignmentTurnedIn />
                <span id="employeesEnrolledCount">{this.state.numMembers} {this.state.employeeText} enrolled</span>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card style={this.state.showUpcomingCharges ? {} : { display: 'none' }}>
            <CardHeader color="success" stats icon>
              <CardIcon  color="cirrusBlue">
                <DateRange />
              </CardIcon>
              <p className={classes.cardCategory}>next charge date</p>
              <h3 className={classes.cardTitle} id="nextChargeDate">{this.state.nextChargeDate}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalAtm />
                withdrawal on or after this date
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12}>
          <Card>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <AttachMoney />
              </CardIcon>
              <h4 id="accountingHeader" className={classes.cardIconTitle}>{this.state.pageTitle}</h4>
            </CardHeader>
            <CardBody>



              <GridContainer style={this.state.showOrgMemberList && this.state.orgMembers.length > 1 ? {} : { display: 'none' }}>
                <GridItem xs={12} sm={12} md={12}>
                  member
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                  >
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.showOrgMemberList && this.state.orgMembers.length > 1 ? this.state.selectedOrgMember : ''}
                      // value={this.state.selectedOrgMember}
                      onChange={this.handleOrgMemberSelect}

                      inputProps={{
                        id: "selectedOrgMember",
                        name: "selectedOrgMember"

                      }}

                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classes.selectMenuItem
                        }}
                      >
                        choose member
                      </MenuItem>
                      {this.state.orgMembers.map((member) =>
                        <MenuItem classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected
                        }} key={member['userId']} value={member['userId']} id={"selectedOrgMemberOption_" + member['userId']} >{member['name']}</MenuItem>
                      )}

                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>



              <GridContainer style={this.state.showNestEggSummaryData && this.state.showOrgMembersTransactions === false ? {} : { display: 'none' }}>
                <GridItem xs={6}>
                  <h4>Nest egg balance: ${this.state.totalBalance}<span style={this.state.nestEggBonusAmount !== '0.00' ? {} : { display: 'none' }}> (includes {this.state.nestEggBonusAmount * 100}% bonus)</span></h4>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={3}>
                  <InputLabel className={classes.label}>from date</InputLabel>
                  <br />
                  <FormControl fullWidth>
                    <Datetime
                      onChange={(event) => {this.handleDateChange(event, 'startDate');}}
                      timeFormat={false}
                      inputProps={{
                        placeholder: "from date",
                        id: "startDate",
                        value: this.state.startDate
                      }}
                      className={classes.dateTimeAlignmentFix}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={3}>
                  <InputLabel className={classes.label}>to date</InputLabel>
                  <br />
                  <FormControl fullWidth>
                    <Datetime
                      onChange={(event) => {this.handleDateChange(event, 'endDate');}}
                      timeFormat={false}
                      inputProps={{
                        placeholder: "to date",
                        id: "endDate",
                        value: this.state.endDate
                      }}
                      className={classes.dateTimeAlignmentFix}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={3}>
                  <Button color="cirrusBlue"  onClick={this.filterAccounting.bind(this)} className={classes.updateProfileButton} type="submit">
                    filter
                  </Button>
                </GridItem>
              </GridContainer>
              <span id="accountingTable">
                <MaterialTable
                  title=''
                  columns={[
                    { title: 'Date', field: 'transactionDatetime'},
                    { title: 'From', field: 'fromUserFullName' },
                    { title: 'To', field: 'toUserFullName' },
                    { title: 'Amount', field: 'transactionAmount' },
                    { title: 'Paid Amount (minus fee, discount)', field: 'payOutAmount', hidden: !this.state.showPayoutAmount },
                    { title: 'Balance', field: 'currentBalance', hidden: !(this.state.showRunningBalanceWithBonus && this.state.showOrgMembersTransactions === false) },
                    { title: 'Balance with ' + this.state.nestEggBonusAmount * 100 + '% bonus', field: 'currentBalanceWithBonus', hidden: !(this.state.showRunningBalance && this.state.showOrgMembersTransactions === false) },
                    { title: '', field: 'actions', hidden: !this.state.showDeleteTransaction },
                  ]}
                  data={this.state.data}
                  options={tableOptions}
                  style={tableStyle}
                />
              </span>
              <CSVLink
                data={this.state.exportData}
                headers={this.state.exportHeaders}
                filename={"cirrusDentalExport.csv"}
                style={this.state.showDownloadData ? {color: cirrusBlueColor} : { display: 'none' }}
              >
                download data
              </CSVLink>
            </CardBody>
          </Card>

          <Card style={this.state.showDeposits ? {} : { display: 'none' }}>
            <CardHeader color="cirrusBlue" icon>
              <CardIcon color="cirrusBlue">
                <AttachMoney />
              </CardIcon>
              <h4 id="depositsHeader" className={classes.cardIconTitle}>{this.state.batchTransactionType}s</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={3}>
                  <InputLabel className={classes.label}>from date</InputLabel>
                  <br />
                  <FormControl fullWidth>
                    <Datetime
                      onChange={(event) => {this.handleDateChange(event, 'depositStartDate');}}
                      timeFormat={false}
                      inputProps={{
                        placeholder: "from date",
                        id: "depositStartDate",
                        value: this.state.depositStartDate
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={3}>
                  <InputLabel className={classes.label}>to date</InputLabel>
                  <br />
                  <FormControl fullWidth>
                    <Datetime
                      onChange={(event) => {this.handleDateChange(event, 'depositEndDate');}}
                      timeFormat={false}
                      inputProps={{
                        placeholder: "to date",
                        id: "depositEndDate",
                        value: this.state.depositEndDate
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={3}>
                  <Button color="cirrusBlue"  onClick={this.filterDeposits.bind(this)} className={classes.updateProfileButton} type="submit">
                    filter
                  </Button>
                </GridItem>
              </GridContainer>
              <MaterialTable
                title=''
                columns={[
                  { title: this.state.batchTransactionType + " date", field: 'transactionDate'},
                  { title: this.state.batchTransactionType + " amount", field: 'totalPayoutAmount' },
                  { title: '# of transactions', field: 'transactionCount' },
                  { title: this.state.batchTransactionType + " ID", field: 'achFilename' }
                ]}
                data={this.state.depositData}
                options={tableOptions}
                style={tableStyle}
              />
              <CSVLink
                data={this.state.depositExportData}
                headers={this.state.depositExportHeaders}
                filename={"cirrusDentalDepositsExport.csv"}
                style={this.state.showDepositDownloadData ? {color: cirrusBlueColor} : { display: 'none' }}
              >
                download data
              </CSVLink>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withRouter(withStyles(styles)(ReactTables));
